const ns = "APPROVAL_WORKFLOW_SPACES";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
